<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title">Pergunta</div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Título</label>
                                    <input type="text" class="form-control" v-model="ask.title" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Dimensão</label>
                                    <select class='form-control' v-model="ask.dimension_id">
                                        <option v-for="dimension in dimensions" :value="dimension.id" :key="dimension.id">{{ dimension.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Tipo</label>
                                    <select class='form-control' v-model="ask.type_id">
                                        <option v-for="askType in askTypes" :value="askType.id" :key="askType.id">{{ askType.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div v-if="ask.type_id == 2">
                            <hr>
                            <div class="row">
                                <div class="col-md-10 offset-md-1">
                                    <div class="card-title">Alternativas</div>
                                </div>
                            </div>
                            <div class="row" v-for="(askOption, index) in askOptions" :key="index">
                                <div class="col-md-9 offset-md-1">
                                    <div class="form-group">
                                        <label>Descrição</label>
                                        <input type="text" class='form-control' v-model="askOption.description">
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <button class='btn btn-red' @click="removeAskOption(index)">
                                        <i class='fa fa-times'></i>
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-11 offset-md-1">
                                    <button class="btn btn-greem" @click="addAskOption()"><i class='fa fa-plus'></i> Adicionar alternativa</button>
                                </div>
                            </div>
                        </div>
                        <div v-if="ask.type_id == 4">
                            <hr>
                            <div class="row">
                                <div class="col-md-10 offset-md-1">
                                    <div class="card-title">Ranking</div>
                                </div>
                            </div>
                            <div class="row" v-for="(askOption, index) in askOptions" :key="index">
                                <div class="col-md-9 offset-md-1">
                                    <div class="form-group">
                                        <label>Opção <strong>{{index}}</strong></label>
                                        <input type="text" class='form-control' v-model="askOption.description">
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <button class='btn btn-red' @click="removeAskOption(index)">
                                        <i class='fa fa-times'></i>
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-11 offset-md-1" v-if="askOptions.length <= 4">
                                    <button class="btn btn-greem" @click="addAskOption()"><i class='fa fa-plus'></i> Adicionar alternativa</button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 text-right">
                                <router-link class='btn btn-return' :to="'/asks'">Voltar</router-link>
                                <button class='btn btn-save' @click="save()">Salvar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            askTypes: [],
            dimensions: [],
            ask: {
                title: "",
                type_id: "",
                dimension_id: ""
            },
            askOptions: [
                {
                    description: ''
                }
            ]
        };
    },
    computed: {},
    methods: {
        removeAskOption(index){
            const self = this
            self.askOptions.splice(index, 1)
        },
        addAskOption(index){
            const self = this
            self.askOptions.push(
                {
                    description: ''
                }
            )
        },
        makeFormData() {
            const self = this;
            let fd = new FormData();

            fd.append('title', self.ask.title)
            fd.append('type_id', self.ask.type_id)
            fd.append('dimension_id', self.ask.dimension_id)

            if(self.ask.type_id == 2 || self.ask.type_id == 4){
                self.askOptions.forEach(askOption => {
                    fd.append('askOptions[]', askOption.description)
                })
            }

            if(self.ask.id){
                fd.append('id', self.ask.id)
                fd.append('_method', 'PUT')
            }

            return fd;
        },
        getAskTypes() {
            const self = this
            const api = self.$store.state.api + "researchasktypes?paginated=false"
            self.$http
                .get(api)
                .then(response => {
                    self.askTypes = response.data.data;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getDimensions() {
            const self = this
            const api = self.$store.state.api + "dimensions?paginated=false"
            self.$http
                .get(api)
                .then(response => {
                    self.dimensions = response.data.data;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getAsk(id){
            const self = this
            const api = self.$store.state.api + "researchasks/" + id + '?with[]=options'
            self.$http
                .get(api)
                .then(response => {
                    let ask = response.data.data[0]
                    if(ask.type_id == 2 || ask.type_id == 4){
                        self.askOptions = ask.options
                        delete ask.options
                    }
                    self.ask = ask;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        save() {
            const self = this
            let api = self.$store.state.api + "researchasks/"

            if(self.ask.id){
                api += self.ask.id
            }

            let fd = self.makeFormData();

            self.$http
                .post(api, fd)
                .then(response => {
                    self.$message(
                        "Sucesso",
                        "Pergunta cadastrada com sucesso",
                        "success"
                    );
                    self.$router.push("/asks");
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        }
    },
    mounted: function() {
        const self = this;
        self.getAskTypes();
        self.getDimensions();
        const id = self.$route.params.id
        if(id){
            self.getAsk(id);
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Ask/Ask.vue